import { toast } from "react-toastify";
import { mainurl } from "./mainurl";
import {
    AllcaseStudyLoading,
  AllcaseStudySuccess,
  AllcaseStudyfail,
  DeletecaseStudyFail,
  DeletecaseStudyLoading,
  DeletecaseStudySuccess,
  GetSinglecaseStudyLoading,
  GetSinglecaseStudySuccess,
  GetSinglecaseStudyfail,
  UpdatecaseStudyCreateLoading,
  UpdatecaseStudyCreateSuccess,
  caseStudyCreateLoading,
  caseStudyCreateSuccess,
  caseStudyCreatefail,
} from "../slices/caseStudySlices";
import axios from "axios"

const baseurl = mainurl;

export const CreateNewcaseStudys = (caseStudydata) => async (dispatch) => {
    console.log(caseStudydata);
  try {
    dispatch(caseStudyCreateLoading());
    const { data } = await axios.post(
      `${baseurl}/case-study/create_casestudy`,
      caseStudydata,
      { withCredentials: true }
    );
    dispatch(caseStudyCreateSuccess(data));
    toast.success("caseStudy created successfully");
  } catch (error) {
    dispatch(caseStudyCreatefail(error.response.data.message));
    toast.error(error.response.data.message);
  }
};

export const AllcaseStudys = async (dispatch) => {
    try {
        dispatch(AllcaseStudyLoading())
        const { data } = await axios.get(`${baseurl}/case-study/get_casestudy`,  { withCredentials: true })
        dispatch(AllcaseStudySuccess(data))
    } catch (error) {
        dispatch(AllcaseStudyfail(error.response.data.message))
    }
}

export const getSinglecaseStudys =(url)=> async (dispatch) => {
    console.log(url);
    try {
        dispatch(GetSinglecaseStudyLoading())
        const { data } = await axios.get(`${baseurl}/case-study/get_single_casestudy/${url}`,  { withCredentials: true })
        dispatch(GetSinglecaseStudySuccess(data))
    } catch (error) {
        dispatch(GetSinglecaseStudyfail(error.response.data.message))
    }
  }

  
  export const UpdatecaseStudys = (id, caseStudydata) => async (dispatch) => {

    try {
        dispatch(UpdatecaseStudyCreateLoading())
        const { data } = await axios.put(`${baseurl}/case-study/update_single_casestudy/${id}`, caseStudydata, { withCredentials: true })
        dispatch(UpdatecaseStudyCreateSuccess(data))
        toast.success("caseStudy updated")
    } catch (error) {
        dispatch(caseStudyCreatefail(error.response.data.message))
        toast.error(error.response.data.message,)
    }
}

export const DeleteSinglecaseStudy = (id) => async (dispatch) => {

    try {
        dispatch(DeletecaseStudyLoading())
        const { data } = await axios.delete(`${baseurl}/case-study/delete_single_casestudy/${id}`, { withCredentials: true })
        dispatch(DeletecaseStudySuccess(data))
        toast.success("Deleted")
    } catch (error) {
        dispatch(DeletecaseStudyFail(error.response.data.message))
        toast.error(error.response.data.message)
    }
}